import { useAuthSDK } from '@/features/auth-sdk';
import { useFavorites } from './useFavorites';

const { syncFavorites } = useFavorites();
const { onAuth } = useAuthSDK();

export function useHandleFavoritesAuth() {
  onAuth(() => {
    syncFavorites()
  })
}
